import { Injectable, inject } from '@angular/core';
import { GaToastVariant, GaToaster } from '@vsn-ux/ngx-gaia';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  private readonly gaToaster = inject(GaToaster);
  private readonly toastIdMap = new Map<string, number>();

  public showInfo(message: string, id: string | null = null, duration: number | null = 5000): void {
    this.showToast('information', message, id, duration);
  }

  public showError(
    message: string,
    id: string | null = null,
    duration: number | null = 15000,
  ): void {
    this.showToast('error', message, id, duration);
  }

  public showSuccess(
    message: string,
    id: string | null = null,
    duration: number | null = 5000,
  ): void {
    this.showToast('success', message, id, duration);
  }

  public showWarning(
    message: string,
    id: string | null = null,
    duration: number | null = 15000,
    title?: string,
  ): void {
    this.showToast('warning', message, id, duration, title);
  }

  public hide(id: string): void {
    const numericId = this.toastIdMap.get(id);
    if (numericId !== undefined) {
      this.gaToaster.hide(numericId);
      this.toastIdMap.delete(id);
    }
  }

  public dismiss(toastId: string): void {
    this.hide(toastId);
  }

  public isToastActive(id: string): boolean {
    const numericId = this.toastIdMap.get(id);
    if (numericId === undefined) {
      return false;
    }
    const isActive = this.gaToaster.toasts().some((toast) => toast.id === numericId);
    if (!isActive) {
      this.toastIdMap.delete(id);
    }
    return isActive;
  }

  private showToast(
    variant: GaToastVariant,
    message: string,
    id: string | null,
    duration: number | null,
    title?: string,
  ): void {
    if (id && this.isToastActive(id)) {
      return;
    }

    const toast = this.gaToaster.show(
      {
        title,
        message,
        variant,
        importance: 'auto',
        dismissible: true,
      },
      duration,
    );

    if (id) {
      this.toastIdMap.set(id, toast.id);
    }
  }
}
